import React from "react";
import StoreIcon from "@mui/icons-material/Store";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import "./HeaderMenu.css";
import { Link } from "react-router-dom";

interface HeaderMenuProps {
  Close: (data: boolean) => void;
}

const HeaderMenu: React.FC<HeaderMenuProps> = ({ Close }) => {
  const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_API || "";
  const INVENTORY_URL = process.env.REACT_APP_INVENTORY_API || "";

  const openNewTabWithToken = (targetUrl: string, appName: string) => {
    const token = sessionStorage.getItem("jsonwebtoken");

    if (!token) {
      console.warn(`⚠️ Token not found in sessionStorage for ${appName}.`);
      alert("Please login first");
      return;
    }


    // Open the target app
    const newTab = window.open(targetUrl, "_blank");

    if (!newTab) {
      console.error("❌ Failed to open new tab (popup blocker?)");
      alert("Please allow popups for this site");
      return;
    }

    const targetOrigin = new URL(targetUrl).origin;
    const now = new Date();
    const timestamp = now.getFullYear() + "-" +
      String(now.getMonth() + 1).padStart(2, "0") + "-" +
      String(now.getDate()).padStart(2, "0") + " " +
      String(now.getHours()).padStart(2, "0") + ":" +
      String(now.getMinutes()).padStart(2, "0") + ":" +
      String(now.getSeconds()).padStart(2, "0");

    // Listen for confirmation from the child window
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === targetOrigin) {
        if (event.data?.status === "ready") {
          // Child window is ready, send token
          try {
            newTab.postMessage(
              {
                token,
                source: "react-app-3000",
                timestamp: timestamp,
              },
              targetOrigin
            );
          } catch (err) {
            console.error(`❌ Error sending token to ${appName}:`, err);
          }
        }

        if (event.data?.status === "Token accepted ✅") {
          window.removeEventListener("message", handleMessage);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // Send token with retry logic (in case child window takes time to load)
    let attempts = 0;
    const maxAttempts = 20; // Increased attempts for slower loading

    const sendToken = () => {
      attempts++;

      try {
        newTab.postMessage(
          {
            token,
            source: "react-app-3000",
            retry: attempts,
          },
          targetOrigin
        );

        if (attempts >= maxAttempts) {
          console.warn(`⚠️ Max attempts reached for ${appName}`);
          clearInterval(interval);
          window.removeEventListener("message", handleMessage);
        }
      } catch (err) {
        console.error(`❌ Error on attempt ${attempts} for ${appName}:`, err);
      }
    };

    const interval = setInterval(sendToken, 800);

    // Cleanup function
    return () => {
      clearInterval(interval);
      window.removeEventListener("message", handleMessage);
    };
  };

  const openNewTabAccountWithToken = () => {
    // openNewTabWithToken(ACCOUNTS_URL, "Accounts");
    Close(false);
  };

  const openInventoryWithToken = () => {
    openNewTabWithToken(INVENTORY_URL, "Inventory");
    Close(false);
  };

  const menuIcons = (path: string, Icon: any, label: string) => {
    return (
      <Link to={path} className='cursor-pointer hover:bg-gray-100 flex flex-col p-1 rounded-lg justify-center items-center' id='menu-icons'>
        <Icon className='feature-icon' />
        <p>{label}</p>
      </Link>
    );
  };

  const dataIcons = (Icon: any, onClick: () => void, name: string) => (
    <div className='cursor-pointer hover:bg-gray-100 flex flex-col p-1 rounded-lg justify-center items-center' onClick={onClick} id='data-icons'>
      <Icon className='feature-icon' />
      <p>{name}</p>
    </div>
  );

  return (
    <div className='w-[440px] grid justify-center items-center p-1 text-black' id='header-menu-container'>
      <div className='w-full'>
        <p className='w-full flex justify-center items-center text-md font-semibold m-1' id='header-additional-title'>
          Additional Features
        </p>
        <div className='flex gap-4 w-full justify-center items-center'>
          {dataIcons(StoreIcon, openInventoryWithToken, "Inventory")}
          {dataIcons(AccountBalanceWalletIcon, openNewTabAccountWithToken, "Accounts")}
        </div>
      </div>
      <div className='w-fit'>
        <p className='w-full flex justify-center items-center text-lg font-semibold m-1' id='header-products-title'>
          Our Company Products
        </p>
        <div className='grid grid-cols-4 gap-4 w-full'>
          {menuIcons("", LocalLaundryServiceIcon, "Laundry")}
          {menuIcons("", LocalCarWashIcon, "Car Wash")}
          {menuIcons("", DirectionsCarIcon, "Car Sales")}
          {menuIcons("", RestaurantIcon, "Restaurant")}
        </div>
      </div>
    </div>
  );
};

export default HeaderMenu;
